import { FlexBox } from "components/Common/FlexBox"
import CloseIcon from "components/Icons/CloseIcon"
import { useBackToHome } from "features/meal/hooks"

const Header = () => {
  const backToHome = useBackToHome()

  return (
    <FlexBox
      style={{ height: 44, padding: "9px 19px", background: "#fff" }}
      $alignItems="center"
    >
      <CloseIcon
        onClick={backToHome}
        style={{
          cursor: "pointer",
        }}
      />
    </FlexBox>
  )
}

export default Header
